module.exports = __webpack_public_path__ + "static/media/eco-ecology-energy-2-svgrepo-com.d5fb4564.svg";